/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospitalBill } from 'app/shared/model/hospital-bill.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { IOPCharge } from 'app/shared/model/op-charge.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IOpProcedureOrder } from 'app/shared/model/op-procedure-order.model';
import { IOpProcedureOrderItem } from 'app/shared/model/op-procedure-order-item.model';
import { IPatientCategory } from 'app/shared/model/patient-category.model';
import { IMiscCharges } from 'app/shared/model/misc-charges.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';

export interface IHospitalOPBillItem {
  id?: string;
  description?: string | null;
  totalCost?: number | null;
  paidAmount?: number | null;
  discount?: number | null;
  billType?: keyof typeof BillType | null;
  active?: boolean | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  lastUpdated?: number | null;
  cursor?: number;
  miscellaneous?: boolean;
  multiplier?: number | null;
  qty?: number | null;
  chargedMrp?: number | null;
  bill?: IHospitalBill | null;
  appointment?: IAppointments | null;
  labBill?: IDiaglabBill | null;
  opService?: IOPCharge | null;
  pharmacyBill?: IPharmacyBill | null;
  order?: IOpProcedureOrder | null;
  orderItem?: IOpProcedureOrderItem | null;
  patientCategory?: IPatientCategory | null;
  miscCharge?: IMiscCharges | null;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IHospitalOPBillItem> = {
  active: false,
  miscellaneous: false,
};
